// extracted by mini-css-extract-plugin
module.exports = {"logoIcon":"LogoIcon__logoIcon","logoIconFixed":"LogoIcon__logoIconFixed"};